// extracted by mini-css-extract-plugin
export default {"root":"Dialog_root__au9MV","content":"Dialog_content__AiVFo"};